import { ThumbsUpIcon } from '@mote/assets/icons'
import { REACTION_EMOJIS } from '@mote/helpers/constants'
import type { MoteActionButtonProps } from '../MoteActionButton'
import { MoteActionButton } from '../MoteActionButton'
import type { ReactionPickerProps } from '../ReactionPicker'
import { ReactionPicker } from '../ReactionPicker'

export interface ReactionButtonProps
  extends Pick<MoteActionButtonProps, 'textPosition'> {
  value?: string | null
  onChange: (value: string | null) => void
  pickerPlacement?: ReactionPickerProps['placement']
  buttonSize?: MoteActionButtonProps['size']
}

export function ReactionButton(props: ReactionButtonProps): JSX.Element {
  const reaction = REACTION_EMOJIS.find(
    reaction => reaction.value === props.value
  )

  const trigger = !reaction ? (
    <MoteActionButton
      onClick={() => props.onChange(REACTION_EMOJIS[0].value)}
      text='Like'
      icon={<ThumbsUpIcon />}
      id='reaction-mote-button'
      ariaLabel='Like'
      textPosition={props.textPosition}
      size={props.buttonSize}
    />
  ) : (
    <MoteActionButton
      onClick={() => props.onChange(null)}
      text={reaction.label}
      icon={reaction.emoji}
      id='reaction-mote-button'
      ariaLabel={reaction.label}
      textPosition={props.textPosition}
      size={props.buttonSize}
    />
  )

  return (
    <ReactionPicker
      onChange={props.onChange}
      triggerElement={trigger}
      placement={props.pickerPlacement}
    />
  )
}
